import {React, useState, useContext, useEffect} from "react";
import ReactDOM from 'react-dom';
import { style, useStyle } from "../../context/styleContext/styleContext";
import Button from '@mui/material/Button';




const AlertModal = ({ isOpen, close, children, message, buttonText }) => {

    const { style, setStyle } = useStyle();
  
    if (!isOpen) return null;

    
    const closeFunction = async (e) => {            
                close() 

    }


        

  return ReactDOM.createPortal(


    
    <div style={modalStyle}>
      <div style={modalContentStyle}>
        <div style={{color:style.color4, backgroundColor:style.color1, width:'90%', margin:'auto'}}>
            
                    <div style={{display:'flex', flex:1, flexDirection:'column', textAlign:'center', width:'90%', margin:'auto'}}>
                        
                          <>
                          <div style={{marginBottom:'75px', marginTop:'0px'}}>
                            <h2>
                              {message} 
                            </h2>
                            
                            </div>
                            <div>
                            <Button onClick={closeFunction} sx={{ my: 2, color:style.color4, display:'block', backgroundColor:style.color1, filter:'brightness(1.2)', boxShadow:10, borderColor:style.color2, fontSize:'14pt', width:'100%', minWidth:'250px', maxWidth:'300px', margin:'auto', marginTop:'0px', borderWidth:'1px', borderStyle:'solid', '&:hover': {backgroundColor: style.color2 }, }}>{buttonText}</Button>
                              </div>
                              </>
                            

                    </div>
           
            
        </div>
      </div>

    </div>,
    document.getElementById('modal-root')
  );
};

const modalStyle = {

    
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.75)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxHeight: '100vh',
  overflowY: 'auto',
  margin:'auto',
  zIndex: "1000",
};

const modalContentStyle = {
  padding: '20px',
  borderRadius: '15px',
  maxWidth: '800px',
  minHeight: '300px',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  width: '90%',
  borderColor: 'rgb(39, 55, 77)',
  color:'rgb(82, 109, 130)',
  borderWidth:'2px',
  borderStyle:'solid',
  backgroundColor: 'rgb(39, 55, 77)',
};

const buttonStyle = {
  marginTop: '20px',
  alignSelf: 'center'
};

export default AlertModal;
